export default __webpack_public_path__ + "static/media/mobile.145d9ce0.png";